import type React from 'react';
import { type FC } from 'react';

import { ClickableLabel } from '../../../../utils/location-detail-modal/styled';
import { TypeRadio } from '../../../../utils/radio';
import { type filterKeys } from '../helper';
import { FilterItemContainer } from '../styled';

interface IRB {
	handleItemSelect: ({ target }: React.ChangeEvent<HTMLInputElement>, key: filterKeys) => void;
	label: string;
	name: filterKeys;
	id: number;
	handleRadioContainerClick: (id: number, key: filterKeys) => void;
	checkedId: number;
	disabled: boolean;
	setOpenTab?: React.Dispatch<React.SetStateAction<boolean>>;
	onTextClick?: (id: number, name: filterKeys) => void;
}

export const RadioBoxItems: FC<IRB> = ({
	handleItemSelect,
	label,
	name,
	id,
	handleRadioContainerClick,
	checkedId,
	disabled,
	setOpenTab,
	onTextClick,
}) => {
	const handleRadioAreaClick = () => {
		handleRadioContainerClick(id, name);
		if (typeof setOpenTab === 'function') setOpenTab(false);
	};

	const handleLabelClick = (e: React.MouseEvent | React.KeyboardEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (onTextClick) {
			onTextClick(id, name);
		}
	};

	const handleLabelKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			handleLabelClick(e);
		}
	};

	return (
		<FilterItemContainer
			className='align-items-center justify-content-start text-left px-1 py-1 w-100'
			title={label}
			hide='false'
			onClick={handleRadioAreaClick}
		>
			<TypeRadio
				onChange={(e) => {
					handleItemSelect(e, name);
					if (typeof setOpenTab === 'function') setOpenTab(false);
				}}
				name={name}
				id={id + ''}
				checked={id === checkedId}
				disabled={disabled}
			/>
			&nbsp;&nbsp;&nbsp;
			{onTextClick ? (
				<ClickableLabel
					onClick={handleLabelClick}
					onKeyDown={handleLabelKeyDown}
					role='button'
					tabIndex={0}
					aria-label={`View details for ${label}`}
					style={{ fontSize: '11px' }}
				>
					{label}
				</ClickableLabel>
			) : (
				<p
					className='m-0'
					style={{ fontSize: '11px', color: 'var(--color-text-primary)' }}
				>
					{label}
				</p>
			)}
		</FilterItemContainer>
	);
};
